import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const TestimonialsSlider = () => {
  const testimonials = [
    {
      text: "As a recent user of disability services, I was pleasantly surprised by the caring and thoughtful help provided by Livability care management and staff. They provided an oasis of calm and stability where their staff are giving each person time in an industry which is overwhelming to me.",
      author: "Waverley Home Participant, SA."
    },
    {
      text: "Livability Care Australia has been a game-changer for our family. The support team is caring, professional, and truly dedicated to making a difference. My brother now has the independence and confidence he never thought possible!",
      author: "Queensland Participant Family"
    },
    {
      text: "The team at Livability Care Australia goes above and beyond! Their support has given me the freedom to live life on my terms while feeling safe and supported. Highly recommend!",
      author: "Sarah, Participant"
    },
    {
      text: "She has gone from being a very solemn person to an active person who now has a purpose in life. This has all happened with the good work of her carers...Also, I feel the move from the nursing home to her own living arrangements is something that others should be encouraged to do.",
      author: "Sandy's mother"
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="w-full mx-auto bg-[#d6bbde] p-8 rounded-lg relative">
      <h2 className="text-5xl font-bold font-arial-rounded text-primary text-center mb-8">
        Testimonials
      </h2>
      
      <div className="relative px-12">
        <button 
          onClick={prevSlide}
          className="absolute left-0 top-1/2 -translate-y-1/2 p-2 hover:bg-purple-200 rounded-full transition-colors"
          aria-label="Previous testimonial"
        >
          <ChevronLeft className="w-6 h-6 text-primary" />
        </button>

        <div className="min-h-[200px] flex items-center justify-center">
          <div className="text-center">
            <p className="text-xl text-primary mb-6 italic">
              "{testimonials[currentIndex].text}"
            </p>
            <p className="text-primary font-medium">
              {testimonials[currentIndex].author}
            </p>
          </div>
        </div>

        <button 
          onClick={nextSlide}
          className="absolute right-0 top-1/2 -translate-y-1/2 p-2 hover:bg-purple-200 rounded-full transition-colors"
          aria-label="Next testimonial"
        >
          <ChevronRight className="w-6 h-6 text-purple-800" />
        </button>
      </div>
    </div>
  );
};

export default TestimonialsSlider;